/// <amd-module name="SuiteCommerce.PhotoGallery.Gallery.View" />
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PhotoGallery.Gallery.View", ["require", "exports", "photogallery_gallery.tpl", "SuiteCommerce.PhotoGallery.Photo.Collection", "Backbone", "SuiteCommerce.PhotoGallery.Common.Utils", "SuiteCommerce.PhotoGallery.Instrumentation", "BxSlider"], function (require, exports, galleryTemplate, PhotoGallery_Photo_Collection_1, Backbone_1, Utils_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GalleryView = /** @class */ (function (_super) {
        __extends(GalleryView, _super);
        function GalleryView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = galleryTemplate;
            _this.container = options.container;
            _this.on('afterViewRender', function () {
                var environment = _this.container.getComponent('Environment');
                // Add link to each photo
                _this.model.get('photosCollection').each(function (photo) {
                    _this.addLink(photo);
                });
                // Run carousel plugin is needed
                if (!environment.isPageGenerator() && _this.model.get('isCarouselEnabled')) {
                    var numberOfSlides = _this.$('.gallery-slider').children().length;
                    if (numberOfSlides > _this.model.get('columnsPerRow')) {
                        setTimeout(function () {
                            var gallerySize = _this.$('.photogallerycct-container').width();
                            var galleryOptions = _this.getSliderOptions(gallerySize);
                            // @ts-ignore
                            _this.$('.gallery-slider').bxSliderNew(galleryOptions);
                        }, 10);
                    }
                }
            });
            return _this;
        }
        GalleryView.prototype.getGalleryRows = function (enableCarousel) {
            var photos = this.model.get('photosCollection');
            var rows = enableCarousel ? [photos] : this.separatePhotosIntoRows(photos);
            var galleryRows = [];
            for (var i = 0; i < rows.length; i++) {
                var rowPhotos = rows[i];
                galleryRows.push({
                    photos: rowPhotos.toJSON(),
                    columnSize: 12 / this.getNumberOfPhotosToDisplay(enableCarousel, rowPhotos.length),
                });
            }
            return galleryRows;
        };
        GalleryView.prototype.separatePhotosIntoRows = function (photos) {
            var rows = [];
            var rowPhotos = null;
            for (var i = 0; i < photos.length; i++) {
                if (rowPhotos === null || rowPhotos.length % this.model.get('columnsPerRow') === 0) {
                    rowPhotos = new PhotoGallery_Photo_Collection_1.PhotoCollection();
                    rows.push(rowPhotos);
                }
                rowPhotos.add(photos.at(i));
            }
            return rows;
        };
        GalleryView.prototype.getSliderOptions = function (gallerySize) {
            var slideSize = this.getSlideSize(gallerySize);
            var self = this;
            return {
                slideSelector: '.column-container',
                slideWidth: slideSize,
                nextText: Utils_1.Utils.isPhoneDevice() ? '' : '<a class="next-icon"></a>',
                prevText: Utils_1.Utils.isPhoneDevice() ? '' : '<a class="prev-icon"></a>',
                minSlides: Utils_1.Utils.isPhoneDevice() ? 1 : this.model.get('columnsPerRow'),
                maxSlides: Utils_1.Utils.isPhoneDevice() ? 1 : this.model.get('columnsPerRow'),
                moveSlides: 1,
                touchEnabled: true,
                auto: this.model.get('carouselAnimationTime') > 0,
                pause: this.model.get('carouselAnimationTime'),
                pager: true,
                onSliderResize: function () {
                    self.reloadSliderOnResize(this);
                },
            };
        };
        GalleryView.prototype.getSlideSize = function (gallerySize) {
            if (Utils_1.Utils.isPhoneDevice()) {
                return gallerySize;
            }
            var numberOfSlides = this.$('.gallery-slider').children().length;
            return gallerySize / this.getNumberOfPhotosToDisplay(this.model.get('isCarouselEnabled'), numberOfSlides);
        };
        GalleryView.prototype.getNumberOfPhotosToDisplay = function (enableCarousel, numberOfPhotos) {
            if (Utils_1.Utils.isPhoneDevice()) {
                return 1;
            }
            return enableCarousel ? this.model.get('columnsPerRow') : numberOfPhotos;
        };
        GalleryView.prototype.reloadSliderOnResize = function (el) {
            var elementContainer = $(el).closest('.photogallerycct-container');
            if (elementContainer) {
                var newContainerWidth = $(elementContainer).width();
                var sliderOptions = this.getSliderOptions(newContainerWidth);
                // @ts-ignore
                el.reloadSlider(sliderOptions);
            }
        };
        GalleryView.prototype.addLink = function (photo) {
            var _this = this;
            var linkTarget = this.$('div.photo-id-' + photo.get('id'));
            var isParentNotALinkTag = !this.$(linkTarget).parent().is('a');
            var target = this.model.get('openLinksInNewWindow') ? '_blank' : '';
            if (isParentNotALinkTag && photo.get('link')) {
                var $anchorElement = jQuery('<a>');
                $anchorElement.attr('href', photo.get('link'));
                if (target)
                    $anchorElement.attr('target', target);
                $anchorElement.on('click', function () { return _this.sendInstrumentationHitForClickOnImage(photo.get('link')); });
                this.$(linkTarget).wrap($anchorElement);
            }
        };
        GalleryView.prototype.sendInstrumentationHitForClickOnImage = function (imageLinkUrl) {
            var log = Instrumentation_1.default.getLog('clickOnImage');
            log.setParameters({
                componentArea: 'SC Photo Gallery',
                activity: 'Click on gallery image',
                message: imageLinkUrl,
            });
            log.submit();
        };
        GalleryView.prototype.getContext = function () {
            var photosCollection = this.model.get('photosCollection');
            var isCarouselEnabled = this.model.get('isCarouselEnabled') && photosCollection.length > this.model.get('columnsPerRow');
            var galleryRows = this.getGalleryRows(isCarouselEnabled);
            var galleryStyle = isCarouselEnabled ? 'carousel' : 'grid';
            var imageHoverAnimationType = !isCarouselEnabled ? this.model.get('imageHoverAnimationType') : '';
            return {
                isCarouselEnabled: isCarouselEnabled,
                galleryRows: galleryRows,
                galleryStyle: galleryStyle,
                imageHoverAnimationType: imageHoverAnimationType,
                galleryHeight: this.model.get('galleryHeightClassName'),
            };
        };
        return GalleryView;
    }(Backbone_1.View));
    exports.GalleryView = GalleryView;
});
